// extracted by mini-css-extract-plugin
export default {"page":"VC1LN_","card":"DVVFkc","subtitle":"J3rIcU","error":"C_SjXW"};